import { Pipe, PipeTransform } from '@angular/core';
import { PropertyDataSourceType } from 'src/app/module/order/interface/order.interface';
import {
  ExtendedPropertyDetail,
  PropertyAttribute,
  PropertyAttributeValue,
} from 'src/app/module/property/interface/property.interface';
import { CommonService } from 'src/app/shared/utility/common.service';
import { PropertyConfig } from '../config/property.config';

@Pipe({
  name: 'selectedSourceData',
  standalone: true,
})
export class SelectedSourceDataPipe implements PipeTransform {
  constructor(private _commonService: CommonService) {}

  transform<T>(obj: PropertyAttributeValue<T> | null | undefined): T | null | undefined;
  transform<T>(
    obj: PropertyAttributeValue<T> | null | undefined,
    dataSource: PropertyDataSourceType | undefined
  ): T | null | undefined;
  transform<T>(
    obj: ExtendedPropertyDetail | null | undefined,
    fieldKey: PropertyAttribute,
    structureIndex?: number,
    unitIndex?: number
  ): T | null | undefined;
  transform<T>(
    obj: PropertyAttributeValue<T> | ExtendedPropertyDetail | null | undefined,
    fieldKeyOrDataSource?: PropertyAttribute | PropertyDataSourceType,
    structureIndex = 0,
    unitIndex = 0
  ): T | null | undefined {
    let pav: PropertyAttributeValue<T> | null | undefined;

    const dataSourceList: readonly PropertyDataSourceType[] = PropertyConfig.propertyDataSourceList;

    const dataSource = dataSourceList.includes(fieldKeyOrDataSource as PropertyDataSourceType)
      ? (fieldKeyOrDataSource as PropertyDataSourceType)
      : undefined;
    const fieldKey = dataSource ? undefined : (fieldKeyOrDataSource as PropertyAttribute | undefined);

    if (fieldKey) {
      pav = this._commonService.resolvePropertyField(
        obj as ExtendedPropertyDetail,
        fieldKey,
        structureIndex,
        unitIndex
      ) as PropertyAttributeValue<T> | undefined;
    } else {
      pav = obj as PropertyAttributeValue<T>;
    }

    const source = dataSource ?? pav?.selectedSource;
    if (pav && source) {
      const value = pav[source];
      if (typeof value === 'string' && value.trim() === '') {
        return null;
      }
      return value as T;
    }
    return null;
  }
}
